import { Navigate } from "react-router-dom";

import useAuth from "@/hooks/useAuth";
import Loader from "../Loader";
import type { GuardProps } from "./types";

function GuestGuard({ children }: GuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) return <Loader />;
  if (isAuthenticated) return <Navigate to="/auth/post-login" replace />;

  return <>{children}</>;
}

export default GuestGuard;
